<div class="dialog">
  <form [formGroup]="emailForm" (ngSubmit)="updateMember(data.user)">
    <mat-dialog-content>
      <div class="header"><h2>Edit Member</h2></div>

      <div class="info-wrapper">
        <p><b>Current Username </b>(NWMO email address)</p>
        <p>{{ data.user.username }}</p>
      </div>

      <div class="info-wrapper">
        <p class="new-username"><b>New Username </b> (NWMO email address)</p>
        <mat-form-field appearance="outline">
          <input
            matInput
            formControlName="newEmail"
            (focus)="clearInputNewAndConfirm()"
          />
          <mat-error
            *ngIf="
              emailForm.get('newEmail')?.hasError('email') &&
              !emailForm.get('newEmail')?.hasError('required')
            "
          >
            Please enter a valid Username.
          </mat-error>
          <mat-error *ngIf="emailForm.get('newEmail')?.hasError('pattern')">
            Username must end with "@nwmo.ca".
          </mat-error>
        </mat-form-field>
      </div>

      <div class="info-wrapper">
        <p><b>Confirm Username</b> (NWMO email address)</p>
        <mat-form-field appearance="outline">
          <input
            matInput
            formControlName="confirmEmail"
            (focus)="clearInputConfirm()"
          />
          <mat-error
            *ngIf="
              emailForm.get('confirmEmail')?.hasError('email') &&
              !emailForm.get('confirmEmail')?.hasError('required')
            "
          >
            Please enter a valid Username.
          </mat-error>
          <mat-error *ngIf="emailForm.get('confirmEmail')?.hasError('pattern')">
            Username must end with "@nwmo.ca".
          </mat-error>
          <mat-error
            *ngIf="emailForm.get('confirmEmail')?.hasError('notMatched')"
          >
            Usernames do not match.
          </mat-error>
        </mat-form-field>
      </div>


      <div class="info-wrapper" style="margin-bottom: 5%;">
        <p><b>Administrator</b></p>
        <mat-button-toggle-group
          name="isAdmin"
          formControlName="isAdmin"
          (change)="isAdmin = !isAdmin"
          appearance="legacy"
        >
          <mat-button-toggle
            value="true"
            [ngClass]="{
              'custom-no': isAdmin == true,
              'custom-yes': isAdmin == false
            }"
            >YES</mat-button-toggle
          >
          <mat-button-toggle
            value="false"
            [ngClass]="{
              'custom-no': isAdmin == false,
              'custom-yes': isAdmin == true
            }"
            >NO</mat-button-toggle
          >
        </mat-button-toggle-group>
  
      </div>
     
      <p><b>Type ‘UPDATE MEMBER’ to confirm changes</b></p>
      <mat-form-field appearance="outline">
        <input
          matInput
          formControlName="confirmationText"
          placeholder="UPDATE MEMBER"
        />
        <mat-error
          *ngIf="
            emailForm.get('confirmationText')?.hasError('required') ||
            emailForm.get('confirmationText')?.hasError('pattern')
          "
        >
          Please type 'UPDATE MEMBER' to confirm changes.
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="center" class="justify-space-between">
      <button
        mat-stroked-button
        color="primary"
        class="blue-outline-button"
        (click)="onNoClick()"
      >
        CANCEL
      </button>
      <button
        mat-flat-button
        color="primary"
        class="button lock"
        type="submit"
        [disabled]="emailForm.invalid"
      >
        UPDATE MEMBER
      </button>
    </mat-dialog-actions>
  </form>
</div>
